import { PrescribedItem } from '../../../../types'

export const getPbsStatus = (item: PrescribedItem) => {
  const pbsType = item.productDetails?.pbs.find((i) => i.pbsCode === item.pbsCode)?.pbsType
  if (item.isPBS || pbsType === 'Extemporaneous Preparations') {
    return 'PBS'
  } else if (item.isRPBS) {
    return 'RPBS'
  } else if (item.privatePrescription) {
    return 'Private'
  } else if (item.isSection100) {
    return 'Section 100'
  }
  return ''
}
